<button mat-icon-button (click)="toggleTheme()" [matTooltip]="themeService.currentThemeValue === 'midnight-obsidian' ? 'Passer au thème Clair' : 'Passer au thème Sombre'">
  @if (themeService.currentThemeValue === 'midnight-obsidian') {
    <mat-icon class="theme-icon-active">wb_sunny</mat-icon>
  } @else {
    <mat-icon class="theme-icon-active">nights_stay</mat-icon>
  }
</button>
